import { apiBaseUrl } from "./config"
import { getBaseHeader } from "./utils"
import { genericFetch }  from './common-service'
import { createFileUploadRequestBody, createFileUpdateRB } from './factory'

export function getAllS3Files() {
	const url = `${apiBaseUrl}/s3/helper/files`
	const init = {
		headers: getBaseHeader(true),
	}

	return genericFetch(url, init)
}

export function uploadFileToS3(
	dataFile: File,
): Promise<any>{
	const url = `${apiBaseUrl}/s3/helper/files`
	const uploadFileObject = createFileUploadRequestBody(
        dataFile)
    const formData = new FormData(); 
    
    // Update the formData object 
    formData.append("file", dataFile);
	const init: any = {
		body: formData,
		headers: {
			...getBaseHeader(),
		},
		method: "POST"
	}
	return genericFetch(url, init)
}

export function updateS3File(id: string, name: string): Promise<any> {
	const url = `${apiBaseUrl}/s3/helper/files/${id}`
	const init: RequestInit = {
		body: JSON.stringify(createFileUpdateRB(name)),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT"
	}

	return genericFetch(url, init)
}

export function updateS3FilePosition(id: string, position: string): Promise<any> {
	const url = `${apiBaseUrl}/s3/helper/files/${id}/position/${position}`
	const init: RequestInit = {
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT"
	}

	return genericFetch(url, init)
}

export function deleteS3File(slug: string) {
	const url = `${apiBaseUrl}/s3/helper/files/${slug}`
	const init = {
		headers: getBaseHeader(true),
		method: "DELETE"
	}

	return genericFetch(url, init)
}

export function uploadFile(id:number,operation:string,page:string,formData:any,year:number): Promise<any> {
	const url = `${apiBaseUrl}/localauthorities/${id}/observation/import/${operation}/${page}?year=${year}`
	const form = new FormData(); 
    
    // Update the formData object 
    form.append("file", formData);
	const init: RequestInit = {
		body: form,
		headers: {
			...getBaseHeader(),
		},
		method: "POST"
	}

	return genericFetch(url, init)
}

export async function uploadFileObservation(id:number,formData:any): Promise<{ message: string }> {
	const url = `${apiBaseUrl}/localauthorities/${id}/observation/import`

	const form = new FormData(); 
    
    // Update the formData object 
    form.append("file", formData);
	const init: RequestInit = {
		body: form,
		headers: {
			...getBaseHeader(),
		},
		method: "POST"
	}

	const response = await fetch(url, init);
	if (response.ok) {
		return await response.json();  // Retourne le JSON si succès
	}
  
	// Si la réponse n'est pas "ok", on essaie de récupérer l'erreur
	let errorBody: { error?: string } | null = null;
	errorBody = await response.json();  
	const errorMessage = errorBody && errorBody.error  ? errorBody.error : 'Une erreur est survenue pendant l\'envoi ou le traitement du fichier.';
	throw new Error(errorMessage);  // Lance une exception avec l'erreur reçue
}

export async function uploadFileObservationValidation(id:number,formData:any): Promise<any[]> {
	const url = `${apiBaseUrl}/localauthorities/${id}/observation/importValidation`

	const form = new FormData(); 
    
    // Update the formData object 
    form.append("file", formData);
	const init: RequestInit = {
		body: form,
		headers: {
			...getBaseHeader(),
		},
		method: "POST"
	}

	const response = await fetch(url, init);
	if (response.ok) {
		return await response.json();  // Retourne le JSON si succès
	}
  
	throw new Error('Une erreur est survenue pendant l\'envoi ou le traitement du fichier.');
}


// WEBPACK FOOTER //
// ./src/service/sfp/file-service.ts